import { createFormatForDescription as cffd } from '../createFormatForDescription'
import SignerEntry from '../types/util/SignerEntry'

import { Explanation, explain } from './Explanation'

/**
 * Explains a SignerEntry object.
 *
 * @property account - An explanation of the account.
 * @property signerWeight - An explanation of the signerWeight.
 */
export interface SignerEntryExplanation {
  readonly account: Explanation<string>
  readonly signerWeight: Explanation<number>
}

/**
 * Creates an explanation for a SignerEntry.
 *
 * @param entry - The entry to be explained.
 * @param entry.SignerEntry - Contains the actual contents of the entry.
 * @returns An explanation of the signer entry.
 */
export function createSignerEntryExplanation(entry: {
  // eslint-disable-next-line @typescript-eslint/naming-convention -- Must follow transaction format.
  readonly SignerEntry: SignerEntry
}): SignerEntryExplanation {
  const mainEntry = entry.SignerEntry

  const account = explain(
    mainEntry.Account,
    `${cffd(
      mainEntry.Account,
      'account',
    )}'s signature contributes to the multi-signature. It does not need to be a funded address in the ledger.`,
  )

  const signerWeight = explain(
    mainEntry.SignerWeight,
    `This account has weight ${cffd(
      mainEntry.SignerWeight.toString(),
      'signerWeight',
    )} in the multi-signature.`,
  )

  return {
    account,
    signerWeight,
  }
}
